import React, { useEffect, useRef } from 'react'

export const useDerivedRef = <D, T = D>(
  derivedValue: D,
  getValue: (derivedValue: D) => T = value => value as unknown as T,
): React.MutableRefObject<T> => {
  const ref = useRef(getValue(derivedValue))

  useEffect(() => {
    ref.current = getValue(derivedValue)
  }, [derivedValue])

  return ref
}
